export default __webpack_public_path__ + "images/a7b86efe25193a8703d255595112a067.svg";